import { Provider } from '@repo/api-gw-sdk';

import type { RestoreAzureSqlDBState } from './restoreAzureSqlDbWizard';
import type { RestoreGcpCloudSqlState } from './restoreGcpCloudSqlWizard';
import type { RestoreRDSState } from './restoreRDSWizard';
import { AzureSqlDbConfiguration } from './steps/azureSqlDbConfiguration';
import { GcpCloudSqlConfiguration } from './steps/gcp/gcpCloudSqlConfiguration';
import { RDSConfiguration } from './steps/rdsConfiguration';

import type { StepProps } from '../wizard/StepProps';

export const ManagedDatabaseConfiguration = (
  props:
    | StepProps<RestoreRDSState>
    | StepProps<RestoreAzureSqlDBState>
    | StepProps<RestoreGcpCloudSqlState>
) => {
  const cloudProvider =
    props.wizardState.restoreAccount?.restoreAccountAttributes.cloudProvider;
  if (cloudProvider === Provider.Aws) {
    return <RDSConfiguration {...(props as StepProps<RestoreRDSState>)} />;
  }

  if (cloudProvider === Provider.Azure) {
    return (
      <AzureSqlDbConfiguration
        {...(props as StepProps<RestoreAzureSqlDBState>)}
      />
    );
  }

  if (cloudProvider === Provider.Gcp) {
    return (
      <GcpCloudSqlConfiguration
        {...(props as StepProps<RestoreGcpCloudSqlState>)}
      />
    );
  }

  return null;
};
